exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Avatar .Avatar-icon {\n  font-size: 120px;\n}\n.UserSettingsDialog {\n  width: 700px;\n}\n.UserSettingsDialog .content {\n  height: 350px;\n}\n", ""]);

// exports
